import snsAxiosClient from '../common/http/http-sns';

function getAllActiveItems(environmentVariables, user) {
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_GET_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };
  return snsAxiosClient(options).get(
    `${environmentVariables.SNS_ALL_ACTIVE_ITEMS_API}${user.UUID}/allActiveSubscriptions`,
  );
}

export default getAllActiveItems;
